// startup
// Load entry module
__webpack_require__("./src/js/app.js");
// This entry module used 'exports' so it can't be inlined
